const modalOpenClass = 'swiper_modal_open';

window.addEventListener('DOMContentLoaded', () => {
  const elements = document.getElementsByClassName(modalOpenClass);
  if (!elements) {
    return;
  }
  if (window.matchMedia('(min-width:601px)').matches) {
    const slideLength = document.querySelectorAll(
      '#swiper_wrap .swiper-slide'
    ).length;
    let options = {};
    if (slideLength === 1) {
      options = {
        containerModifierClass: 'swiper_passive',
        allowTouchMove: false,
        loop: 'false',
        speed: 400,
        navigation: {
          nextEl: '.swiper-button-next',
          prevEl: '.swiper-button-prev',
        },
      };
    } else {
      options = {
        allowTouchMove: false,
        loop: 'true',
        speed: 400,
        navigation: {
          nextEl: '.swiper-button-next',
          prevEl: '.swiper-button-prev',
        },
      };
    }

    let projectSwiper = new Swiper('.swiper', options);

    Array.from(elements).forEach((element) => {
      element.addEventListener('click', (event) => {
        projectSwiper.slideTo(element.id);

        event.preventDefault();
        $('#modal').addClass('open');
        $('body').addClass('hidden');
      });
    });
  }
});

if (window.matchMedia('(min-width:601px)').matches) {
  $('#modal_close, #modal_background').on('click', function (e) {
    $('#modal').removeClass('open');
    $('body').removeClass('hidden');
  });
}
